import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton,
  ModalBody, ModalFooter, Button, Text, Input, SimpleGrid, Box,
  VStack, useToast, Select, InputGroup, InputRightElement, InputLeftElement,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Divider,
  FormControl,
  FormLabel,
  HStack,
  IconButton,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Stack,
  Stat,
  StatLabel,
  StatNumber,
  Switch,
  Table,
  Tag,
  Tbody,
  Td,
  Th,
  Thead,
  Tr
} from '@chakra-ui/react';
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';
import { GOOGLE_MAPS_API_KEY } from 'config/googleMaps';

// ==== NUEVO: importa el catálogo SCIAN desde un JSON en la misma carpeta ====
import scianCatalogRaw from './giros_scian.json';
import { MdAdd, MdDelete } from 'react-icons/md';

// Tipado del JSON SCIAN
interface ScianItem {
  ID: number;
  CLAVE_SCIAN: number;
  ESTRUCTURA_SCIAN: string;
  DESCRIPCION: string;
  RECOLECCION_RESIDUOS_SOLIDOS?: string | null;
  LICENCIA_COFEPRIS?: string | null;
  MONTO_UMA: string;     // p.e. "500 a 550 UMA"
  minimo_uma: number;
  maximo_uma: number;
}

const catalogoGiros: Record<string, string[]> = {
  "Alimentación y Bebidas": [
    "Tortillería (elaboración y venta)",
    "Restaurante familiar",
    "Restaurante de comida rápida",
    "Cafetería",
    "Lonchería",
    "Taquería",
    "Pizzería",
    "Marisquería",
    "Tortería",
    "Panaderia artesanal",
    "Panadería y pastelería",
    "Cenaduría",
    "Comida corrida",
    "Crepería",
    "Fuente de sodas",
    "Juguería / licuados",
    "Puesto de antojitos mexicanos",
    "Birriería",
    "Barbacoería / Venta de barbacoa",
    "Antojeria",
    "Pollos a la leña",
    "Venta de pollos rostizados con servicio en mesa",
    "Pollos rostizados",
    "Frituras",
    "Hamburguesería",
    "Comida oriental (sushi, ramen, etc.)",
    "Comida internacional (italiana, argentina, etc.)",
    "Bar con venta de cerveza, vinos y licores",
    "Cantina",
    "Cervecería artesanal",
    "Centro botanero",
    "Salón de banquetes y eventos",
    "Food truck / cocina móvil",
  ],
  "Comercio de Alimentos": [
    "Tendajón","Abarrotes","Frutería","Verdulería","Carnicería","Pescadería","Cremería",
    "Tienda naturista","Tortillería (solo venta)","Tienda de productos gourmet",
    "Tienda de conveniencia","Venta de productos orgánicos","Bodega de alimentos",
  ],
  "Comercio de Ropa, Calzado y Accesorios": [
    "Boutique de ropa","Zapatería","Tienda de ropa deportiva","Tienda de ropa de segunda mano",
    "Sastrería","Tienda de accesorios y bisutería","Tienda de bolsos y marroquinería",
    "Tienda de ropa infantil","Tienda de uniformes","Tienda de ropa interior y lencería",
  ],
  "Servicios Personales": [
    "Estética unisex","Barbería","Spa y masajes","Centro de uñas y manicure","Maquillaje profesional",
    "Peluquería tradicional","Servicios de tatuajes y perforaciones","Clínica de depilación láser",
    "Salón de bronceado",
  ],
  "Salud": [
    "Consultorio médico general","Consultorio dental","Consultorio psicológico","Consultorio nutricional",
    "Óptica","Laboratorio clínico","Farmacia sin consultorio","Farmacia con consultorio","Clínica veterinaria",
  ],
  "Educación y Capacitación": [
    "Guardería o estancia infantil","Escuela de idiomas","Escuela de computación","Escuela de música",
    "Academia de baile","Centro de regularización escolar","Centro de capacitación técnica","Taller de artes y oficios",
  ],
  "Entretenimiento y Recreación": [
    "Gimnasio","Cancha de fútbol rápido","Cancha de pádel","Centro de yoga o pilates","Cine","Billar",
    "Sala de videojuegos","Salón de fiestas infantiles","Parque de trampolines","Centro cultural o galería",
    "Academia de artes marciales",
  ],
  "Comercio de Bienes y Servicios Generales": [
    "Ferretería","Papelería","Librería","Florería","Tienda de regalos","Tienda de globos","Juguetería",
    "Tienda de artículos para mascotas","Tienda de electrónica y accesorios","Tienda de celulares y accesorios",
    "Refaccionaria","Tienda de autopartes","Venta de maquinaria ligera","Venta de muebles y decoración",
    "Venta de materiales para construcción",
  ],
  "Servicios Profesionales": [
    "Despacho contable","Despacho jurídico","Agencia de viajes","Agencia de publicidad",
    "Agencia de bienes raíces","Consultoría empresarial","Estudio fotográfico","Servicios de impresión y copias",
    "Diseño gráfico e impresión","Desarrollo de software",
  ],
  "Servicios Automotrices": [
    "Taller mecánico","Taller de hojalatería y pintura","Lavado y detallado de autos",
    "Venta de autopartes nuevas","Venta de autopartes usadas","Taller de motos",
    "Estación de servicio (gasolinera)","Taller eléctrico automotriz","Servicio de alineación y balanceo",
  ],
  "Hospedaje y Turismo": [ "Hotel","Hostal","Motel","Cabañas","Glamping","Casa de huéspedes" ],
  "Comercio": [
    "Venta de elotes y esquites","Venta de churros y buñuelos","Venta de tamales y atole",
    "Venta de flores en vía pública","Venta de artesanías en tianguis",
  ],
  "Otros":['Sin Especificar']
};

interface Licencia {
  Id: number;
  ine: string | null;
  usuarioId: number;
  FolioLicencia: string | null;
  Estatus: string | null;
  Ciudadano: string;
  nombreEstablecimiento?: string;
  giro: string | null;
  tipo: string | null;
  Movimiento: string | null;
  localidad?: string | null;
  direccionx: string | null;
  calle?: string | null;
  numero?: string | null;
  codigoPostal?: string | null;
  Horario: string | null;
  fechaRegistro: string;
  montoLicencia?: number;
  montoResiduos?: number;
  residuos?: boolean;
  lat?: number;
  lng?: number;
  // NUEVOS :
  ESTRUCTURA_SCIAN?: string | null;
  CLAVE_SCIAN?: number | null;
  MONTO_UMA?: string | null;
  minimo_uma?: number | null;
  maximo_uma?: number | null;
  DESCRIPCION?: string | null;
}

interface ModalSolicitudProps {
  isOpen: boolean;
  onClose: () => void;
  archivos: { recibo?: File; fotos?: File[] };
  handleArchivoChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    tipo: string,
    multiple?: boolean
  ) => void;
  modo: 'new' | 'edit' | 'view';
  data?: Licencia;
}

const ModalSolicitud: React.FC<ModalSolicitudProps> = ({
  isOpen, onClose, archivos, handleArchivoChange, modo, data
}) => {
  const toast = useToast();
  const user = useSelector((state: RootState) => state.auth.user);

  // ==== SCIAN state ====
  const scianCatalog = (scianCatalogRaw as ScianItem[]) || [];
  const [scianId, setScianId] = useState<number | ''>('');
  const [ESTRUCTURA_SCIAN, setESTRUCTURA_SCIAN] = useState('');
  const [CLAVE_SCIAN, setCLAVE_SCIAN] = useState<number | ''>('');
  const [MONTO_UMA, setMONTO_UMA] = useState('');         // texto "X a Y UMA"
  const [minimo_uma, setMinimoUma] = useState<number | ''>('');
  const [maximo_uma, setMaximoUma] = useState<number | ''>('');
  const [DESCRIPCION, setDESCRIPCION] = useState('');

  // ==== Form state (existente) ====
  const [nombre, setNombre] = useState('');
  const [FolioLicencia, setFolioLicencia] = useState('');
  const [nombreEstablecimiento, setNombreEstablecimiento] = useState('');
  const [giro, setGiro] = useState('');
  const [tipo, setTipo] = useState('');
  const [conceptoTmp, setConceptoTmp] = useState('');
const [montoTmp, setMontoTmp] = useState<number | ''>('');

  // Nuevo tipo
// type ConceptoItem = { nombre: string; monto: number };

// Estado nuevo
const [conceptos, setConceptos] = useState<ConceptoItem[]>([]);
const [concepto, setConcepto] = useState(''); // reemplaza el antiguo 'movimiento'
  const [aliasGiro, setAliasGiro] = useState('');

  const [Estatus, setEstatus] = useState('');
  
  // const [movimiento, setMovimiento] = useState('');
  const [horario, setHorario] = useState('');
  const [residuos, setResiduos] = useState(false);
  const [montoResiduos, setMontoResiduos] = useState('');
  const [montoLicencia, setMontoLicencia] = useState('');
  const [direccionx, setDireccionx] = useState('');
  const [localidad, setLocalidad] = useState('');
  const [calle, setCalle] = useState('');
  const [codigoPostal, setCodigoPostal] = useState('');
  const [numero, setNumero] = useState('');
  const [direccion, setDireccion] = useState('');
  const [lat, setLat] = useState(19.4326);
  const [lng, setLng] = useState(-99.1332);
  // === DERIVADOS (antes del return) ===
const totalConceptos = useMemo(
  () => conceptos.reduce((acc, it) => acc + (Number(it.monto) || 0), 0),
  [conceptos]
);

const totalPagar = useMemo(
  () =>
    (parseFloat(montoLicencia || '0') || 0) +
    (residuos ? (parseFloat(montoResiduos || '0') || 0) : 0) +
    totalConceptos,
  [montoLicencia, montoResiduos, residuos, totalConceptos]
);

  const [fechaRegistro, setFechaRegistro] = useState(() => {
const totalConceptos = conceptos.reduce((acc, it) => acc + (Number(it.monto) || 0), 0);
const totalPagar =
  (parseFloat(montoLicencia || '0') || 0) +
  (residuos ? (parseFloat(montoResiduos || '0') || 0) : 0) +
  totalConceptos;

    const hoy = new Date();
    return hoy.toISOString().split('T')[0];
  });
  const [ine, setIne] = useState('');

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: ['places'],
  });

  type ConceptoItem = { nombre: string; monto: number };

const toNumber = (v: any, def = 0) => {
  if (v === null || v === undefined || v === '') return def;
  const s = String(v).replace(/[,\s]/g, '');
  const n = Number(s);
  return isNaN(n) ? def : n;
};

const strip = (s: string) =>
  s
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, ''); // quita acentos

const GIRO_SIN_ESPECIFICAR = 'Sin Especificar';

// Lista aplanada normalizada de giros del catálogo
const allGirosNorm = useMemo(
  () => Object.values(catalogoGiros).flat().map(g => strip(g)),
  []
);

// ¿Existe en el catálogo?
const giroEnCatalogo = (g: string) => allGirosNorm.includes(strip(g));

const parseConceptosFromMovimiento = (mov: any): ConceptoItem[] => {
  if (!mov || typeof mov !== 'string') return [];
  return mov
    .split('|')
    .map(t => t.trim())
    .filter(Boolean)
    .map(token => {
      const [nombreRaw, montoRaw] = token.split(':');
      return {
        nombre: (nombreRaw ?? token).trim(),
        monto: toNumber(montoRaw ?? 0, 0),
      };
    })
    .filter(x => x.nombre.length > 0);
};


  // Cargar datos si edit/view
  useEffect(() => {
    if ((modo === 'edit' || modo === 'view') && data) {
      const giroData = data.giro || '';

    if (!giroData) {
      setGiro('');
      setAliasGiro('');
    } else if (giroEnCatalogo(giroData)) {
      // Existe en catálogo → setea normal y oculta alias
      setGiro(giroData);
      setAliasGiro('');
    } else {
      // No existe → fuerza "Sin Especificar" y muestra ALIAS con el valor original
      setGiro(GIRO_SIN_ESPECIFICAR);
      setAliasGiro(giroData);
    }
     
      setNombre(data.Ciudadano || '');
      setIne(data.ine || '');
      setFolioLicencia(data.FolioLicencia || '');
      setNombreEstablecimiento(data.nombreEstablecimiento || '');
      //setGiro(data.giro || '');
      setTipo(data.tipo || '');
      setEstatus(data.Estatus || '');

          const lista = parseConceptosFromMovimiento(data.Movimiento);
    setConceptos(lista);
    setConcepto(''); // o setConceptoTmp('') si usas la variante “atractiva”

    // --- Monto licencia / residuos (vienen como string en tu JSON)
    setMontoLicencia(String(toNumber(data.montoLicencia, 0)));
    setMontoResiduos(String(toNumber(data.montoResiduos, 0)));
    setResiduos(Boolean(data.residuos) || toNumber(data.montoResiduos, 0) > 0);
      // setConcepto(data.Movimiento || '');
      setHorario(data.Horario || '');
      setDireccionx(data.direccionx || '');
      setLocalidad(data.localidad || '');
      setCalle(data.calle || '');
      setCodigoPostal(data.codigoPostal || '');
      setNumero(data.numero || '');
      setFechaRegistro(data.fechaRegistro?.split('T')[0] || '');
      setMontoLicencia(data.montoLicencia?.toString() || '');
      setMontoResiduos(data.montoResiduos?.toString() || '');
      setResiduos(data.residuos || false);
      setLat(data.lat || 19.4326);
      setLng(data.lng || -99.1332);

      // Cargar SCIAN si viene en data
      setESTRUCTURA_SCIAN(data.ESTRUCTURA_SCIAN || '');
      setCLAVE_SCIAN(data.CLAVE_SCIAN ?? '');
      setMONTO_UMA(data.MONTO_UMA || '');
      setMinimoUma(data.minimo_uma ?? '');
      setMaximoUma(data.maximo_uma ?? '');
      setDESCRIPCION(data.DESCRIPCION || '');

      // Seleccionar el ID si lo encontramos por estructura o clave
      const match =
        scianCatalog.find(it => it.ESTRUCTURA_SCIAN === data.ESTRUCTURA_SCIAN) ||
        scianCatalog.find(it => it.CLAVE_SCIAN === data.CLAVE_SCIAN);
      setScianId(match?.ID ?? '');
    }
  }, [modo, data]); // eslint-disable-line

  // Buscar dirección en Google
  const buscarDireccion = () => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address: direccion }, (results, status) => {
      if (status === 'OK' && results[0]) {
        const loc = results[0].geometry.location;
        setLat(loc.lat());
        setLng(loc.lng());
        setDireccion(results[0].formatted_address);
      } else {
        toast({ title: 'Dirección no encontrada', description: 'Revisa la dirección ingresada.', status: 'error' });
      }
    });
  };

  // Manejar selección de SCIAN
  const onChangeScian = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const val = e.target.value ? Number(e.target.value) : '';
    setScianId(val);
    if (!val) {
      setESTRUCTURA_SCIAN('');
      setCLAVE_SCIAN('');
      setMONTO_UMA('');
      setMinimoUma('');
      setMaximoUma('');
      setDESCRIPCION('');
      return;
    }
    const item = scianCatalog.find(x => x.ID === Number(val));
    if (item) {
      setESTRUCTURA_SCIAN(item.ESTRUCTURA_SCIAN || '');
      setCLAVE_SCIAN(item.CLAVE_SCIAN ?? '');
      setMONTO_UMA(item.MONTO_UMA || '');
      setMinimoUma(item.minimo_uma ?? '');
      setMaximoUma(item.maximo_uma ?? '');
      setDESCRIPCION(item.DESCRIPCION || '');
    }
  };

  const handleSubmit = async () => {
const giroFinal = giro === 'Sin Especificar' && aliasGiro.trim() ? aliasGiro.trim() : giro;
const resumenConceptos = conceptos.map(c => `${c.nombre}:${Number(c.monto) || 0}`).join(' | ');

    // Validación de campos obligatorios
    if (!FolioLicencia.trim()) {
      toast({ title: 'Campo requerido', description: 'El folio de licencia es obligatorio.', status: 'error' });
      return;
    }
    if (!nombre.trim()) {
      toast({ title: 'Campo requerido', description: 'El nombre del ciudadano es obligatorio.', status: 'error' });
      return;
    }
    if (!nombreEstablecimiento.trim()) {
      toast({ title: 'Campo requerido', description: 'El nombre del establecimiento es obligatorio.', status: 'error' });
      return;
    }
    if (!direccionx.trim()) {
      toast({ title: 'Campo requerido', description: 'La dirección es obligatoria.', status: 'error' });
      return;
    }
    if (!localidad.trim()) {
      toast({ title: 'Campo requerido', description: 'La localidad es obligatoria.', status: 'error' });
      return;
    }

    if (!user?.id) {
      toast({ title: 'Error', description: 'Usuario no autenticado.', status: 'error' });
      return;
    }

    
    const payload: Licencia = {
      usuarioId: user.id,
      Ciudadano: nombre,
      ine: ine,
      FolioLicencia,
      nombreEstablecimiento,
      giro:giroFinal,
      tipo,
      Estatus,
      Movimiento: resumenConceptos,
      Horario: horario,
      direccionx,
      localidad,
      calle: calle,
      codigoPostal,
      numero,
      montoLicencia: parseFloat(montoLicencia) || 0,
      montoResiduos: parseFloat(montoResiduos) || 0,
      residuos,
      lat,
      lng,
      fechaRegistro: new Date(fechaRegistro).toISOString(),

      // SCIAN en payload:
      ESTRUCTURA_SCIAN,
      CLAVE_SCIAN: CLAVE_SCIAN === '' ? null : Number(CLAVE_SCIAN),
      MONTO_UMA:0,
      minimo_uma: minimo_uma === '' ? null : Number(minimo_uma),
      maximo_uma: maximo_uma === '' ? null : Number(maximo_uma),
      DESCRIPCION,
    } as unknown as Licencia;

    const endpoint = modo === 'edit'
      ? `https://totolac-backend.togui.com.mx/api/licencias-comercio/${data?.Id}`
      : 'https://totolac-backend.togui.com.mx/api/licencias-comercio';

    const method = modo === 'edit' ? 'PUT' : 'POST';

    try {

          // alert(JSON.stringify(payload))

      const res = await fetch(endpoint, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
 
      // alert('mmmjuum');
      const result = await res.json();
      if (!res.ok) throw new Error(result.message || 'Error al guardar');

      toast({
        title: modo === 'edit' ? 'Actualizado' : 'Registrado',
        description: 'La solicitud fue procesada correctamente.',
        status: 'success',
      });

      onClose();
    } catch (err: any) {
      toast({ title: 'Error', description: err.message, status: 'error' });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          bgImage="url('/img/bg.webp')"
          bgSize="cover"
          bgPosition="center"
          bgRepeat="no-repeat"
          color="white"
          textShadow="2px 2px 4px rgba(0,0,0,0.7)"
          fontWeight="bold"
          position="relative"
        >
          Registro de Licencia
        </ModalHeader>
        <ModalCloseButton color="white" _hover={{ bg: 'rgba(255,255,255,0.2)' }} />
        <ModalBody pb={6} maxHeight="70vh" overflowY="auto">
          <VStack spacing={6} align="stretch">

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
              <Input type="date" value={fechaRegistro} onChange={(e) => setFechaRegistro(e.target.value)} isReadOnly={modo === 'view'} />
              <Input 
                placeholder="Folio de Licencia *" 
                value={FolioLicencia} 
                onChange={(e) => setFolioLicencia(e.target.value)} 
                isReadOnly={modo === 'view'}
                borderColor={!FolioLicencia.trim() && modo !== 'view' ? 'red.300' : undefined}
                _placeholder={{ color: !FolioLicencia.trim() && modo !== 'view' ? 'red.400' : 'gray.400' }}
              />
            </SimpleGrid>

            <Text fontWeight="bold" fontSize="lg">Datos del Titular</Text>
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
              <Input 
                placeholder="Nombre del Ciudadano *" 
                value={nombre} 
                onChange={(e) => setNombre(e.target.value)} 
                isReadOnly={modo === 'view'}
                borderColor={!nombre.trim() && modo !== 'view' ? 'red.300' : undefined}
                _placeholder={{ color: !nombre.trim() && modo !== 'view' ? 'red.400' : 'gray.400' }}
              />
              <Input placeholder="INE" value={ine} onChange={(e) => setIne(e.target.value)} isReadOnly={modo === 'view'} />
            </SimpleGrid>

            <Text fontWeight="bold" fontSize="lg">Datos del Establecimiento</Text>
            <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
              <Input 
                placeholder="Nombre del Establecimiento *" 
                value={nombreEstablecimiento} 
                onChange={(e) => setNombreEstablecimiento(e.target.value)} 
                isReadOnly={modo === 'view'}
                borderColor={!nombreEstablecimiento.trim() && modo !== 'view' ? 'red.300' : undefined}
                _placeholder={{ color: !nombreEstablecimiento.trim() && modo !== 'view' ? 'red.400' : 'gray.400' }}
              />
              <Input 
                placeholder="Dirección *" 
                value={direccionx} 
                onChange={(e) => setDireccionx(e.target.value)} 
                isReadOnly={modo === 'view'}
                borderColor={!direccionx.trim() && modo !== 'view' ? 'red.300' : undefined}
                _placeholder={{ color: !direccionx.trim() && modo !== 'view' ? 'red.400' : 'gray.400' }}
              />
              <Select 
                value={localidad || ''} 
                onChange={(e) => setLocalidad(e.target.value)} 
                isDisabled={modo === 'view'}
                borderColor={!localidad.trim() && modo !== 'view' ? 'red.300' : undefined}
              >
                <option value="">Selecciona una localidad *</option>
                <option>San Juan Totolac</option>
                <option>Acxotla del Río</option>
                <option>La Trinidad Chimalpa</option>
                <option>Los Reyes Quiahuixtlan</option>
                <option>San Francisco Ocotelulco</option>
                <option>La Candelaria Teotlalpan</option>
                <option>Santiago Tepeticpac</option>
                <option>San Miguel Tlahuico</option>
                <option>Zaragoza</option>
              </Select>
              <Input placeholder="Código Postal" value={codigoPostal} onChange={(e) => setCodigoPostal(e.target.value)} isReadOnly={modo === 'view'} />
              <Input placeholder="Número" value={numero} onChange={(e) => setNumero(e.target.value)} isReadOnly={modo === 'view'} />

              {/* Select original de giro (optgroups) */}
              <Select
                placeholder="Selecciona el giro"
                value={giro}
                onChange={(e) => setGiro(e.target.value)}
                isDisabled={modo === "view"}
              >
                {Object.entries(catalogoGiros).map(([categoria, giros]) => (
                  <optgroup key={categoria} label={categoria}>
                    {giros.map((g, idx) => (
                      <option key={idx} value={g}>
                        {g}
                      </option>
                    ))}
                  </optgroup>
                ))}
              </Select>
{giro === 'Sin Especificar' && (
  <Input
    placeholder="ALIAS del giro (requerido si eliges 'Sin Especificar')"
    value={aliasGiro}
    onChange={(e) => setAliasGiro(e.target.value)}
    isReadOnly={modo === 'view'}
  />
)}

              <Select placeholder="Tipo" value={tipo} onChange={(e) => setTipo(e.target.value)} isDisabled={modo === 'view'}>
                <option>Anual</option>
                <option>Temporal</option>
              </Select>
              <Select placeholder="Estatus" value={Estatus} onChange={(e) => setEstatus(e.target.value)} isDisabled={modo === 'view'}>
                <option>Apertura</option>
                <option>Refrendo</option>
              </Select>
                            <Input placeholder="Horario" value={horario} onChange={(e) => setHorario(e.target.value)} isReadOnly={modo === 'view'} />

              </SimpleGrid>
          <Box gridColumn={{ md: '1 / -1' }}>
  <Card variant="outline" borderRadius="2xl" shadow="lg">
    <CardHeader pb={2}>
      <HStack justify="space-between" align="center">
        <HStack>
          <Text fontWeight="bold" fontSize="xl">Cobro</Text>
          <Tag colorScheme="red" variant="subtle">
            {conceptos.length} concepto{conceptos.length === 1 ? '' : 's'}
          </Tag>
        </HStack>

        {/* Total (usa tu totalPagar calculado con useMemo) */}
        <Stat textAlign="right">
          <StatLabel>Total a Pagar</StatLabel>
          <StatNumber>${totalPagar.toFixed(2)}</StatNumber>
        </Stat>
      </HStack>
    </CardHeader>

    <CardBody pt={0}>
      {/* Fila para agregar concepto */}
      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} mt={4}>
        <FormControl isDisabled={modo === 'view'}>
          <FormLabel>Concepto</FormLabel>
          <Select
            placeholder="Selecciona un concepto"
            value={conceptoTmp}
            onChange={(e) => setConceptoTmp(e.target.value)}
          >
            <option>Cambio de giro</option>
            <option>Cambio de propietario</option>
            <option>Baja temporal</option>
            <option>Multa</option>
          </Select>
        </FormControl>

        <FormControl isDisabled={modo === 'view'}>
          <FormLabel>Monto</FormLabel>
          <InputGroup>
            <InputLeftElement pointerEvents="none"></InputLeftElement>
            <NumberInput
              value={montoTmp === '' ? '' : Number(montoTmp)}
              onChange={(_, n) => setMontoTmp(isNaN(n) ? '' : n)}
              min={0}
              precision={2}
              step={10}
            >
              <NumberInputField placeholder="0.00" />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
          </InputGroup>
        </FormControl>

        <FormControl>
          <FormLabel>&nbsp;</FormLabel>
          <Button
            leftIcon={<MdAdd />}
            colorScheme="red"
            onClick={() => {
              if (modo === 'view') return;
              if (!conceptoTmp) {
                toast({ status: 'warning', title: 'Selecciona un concepto' });
                return;
              }
              const monto = Number(montoTmp) || 0;
              setConceptos(prev => {
                // evita duplicados; si existe, actualiza monto
                const idx = prev.findIndex(p => p.nombre === conceptoTmp);
                if (idx >= 0) {
                  const copy = [...prev];
                  copy[idx] = { ...copy[idx], monto };
                  return copy;
                }
                return [...prev, { nombre: conceptoTmp, monto }];
              });
              setConceptoTmp('');
              setMontoTmp('');
            }}
            isDisabled={modo === 'view'}
          >
            Agregar
          </Button>
        </FormControl>
      </SimpleGrid>

      <Divider my={4} />

      {/* Tabla de conceptos */}
      <Table size="sm" variant="simple">
        <Thead>
          <Tr>
            <Th>Concepto</Th>
            <Th isNumeric>Monto</Th>
            <Th></Th>
          </Tr>
        </Thead>
        <Tbody>
          {conceptos.length === 0 ? (
            <Tr>
              <Td colSpan={3}>
                <Text fontSize="sm" color="gray.500">Sin conceptos aún</Text>
              </Td>
            </Tr>
          ) : conceptos.map((c, idx) => (
            <Tr key={`${c.nombre}-${idx}`}>
              <Td>{c.nombre}</Td>
              <Td isNumeric width="220px">
                <InputGroup justifyContent="flex-end">
                  <InputLeftElement pointerEvents="none"></InputLeftElement>
                  <NumberInput
                    value={Number(c.monto)}
                    onChange={(_, n) => {
                      const val = isNaN(n) ? 0 : n;
                      setConceptos(prev => prev.map((it, i) => i === idx ? { ...it, monto: val } : it));
                    }}
                    min={0}
                    precision={2}
                    step={10}
                    isDisabled={modo === 'view'}
                    width="full"
                  >
                    <NumberInputField />
                    <NumberInputStepper>
                      <NumberIncrementStepper />
                      <NumberDecrementStepper />
                    </NumberInputStepper>
                  </NumberInput>
                </InputGroup>
              </Td>
              <Td textAlign="right" width="80px">
                {modo !== 'view' && (
                  <IconButton
                    aria-label="Quitar"
                    icon={<MdDelete />}
                    variant="ghost"
                    onClick={() => setConceptos(prev => prev.filter((_, i) => i !== idx))}
                  />
                )}
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      <Stack direction={{ base: 'column', md: 'row' }} mt={6} spacing={4} align="center" justify="space-between">
        {/* Residuos */}
        <HStack spacing={4}>
          <Switch
            isChecked={residuos}
            onChange={(e) => setResiduos(e.target.checked)}
            isDisabled={modo === 'view'}
            colorScheme="red"
          />
          <Text>¿Genera Residuos?</Text>

          {residuos && (
            <InputGroup minW="260px">
              <NumberInput
                value={parseFloat(montoResiduos || '0')}
                onChange={(_, n) => setMontoResiduos(String(isNaN(n) ? 0 : n))}
                min={0}
                precision={2}
                step={10}
                isDisabled={modo === 'view'}
                width="full"
              >
                <NumberInputField placeholder="Monto residuos" />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
            </InputGroup>
          )}
        </HStack>
          <Text>Monto Licencia</Text>

        {/* Monto base de licencia */}
        <InputGroup minW="260px">
          <InputLeftElement></InputLeftElement>
          <NumberInput
            value={parseFloat(montoLicencia || '0')}
            onChange={(_, n) => setMontoLicencia(String(isNaN(n) ? 0 : n))}
            min={0}
            precision={2}
            step={50}
            isDisabled={modo === 'view'}
            width="full"
          >
            <NumberInputField placeholder="Monto de licencia" />
            <NumberInputStepper>
              <NumberIncrementStepper />
              <NumberDecrementStepper />
            </NumberInputStepper>
          </NumberInput>
        </InputGroup>
      </Stack>
    </CardBody>

    <CardFooter pt={0} justify="flex-end">
      <HStack spacing={6}>
        <HStack>
          <Text color="gray.500">Moneda:</Text>
          <Tag>MXN</Tag>
        </HStack>
        <Stat>
          <StatLabel color="gray.500">Total a Pagar</StatLabel>
          <StatNumber>${totalPagar.toFixed(2)}</StatNumber>
        </Stat>
      </HStack>
    </CardFooter>
  </Card>
</Box>


            {/* ========== NUEVO BLOQUE: GIRO COMERCIAL  ========== */}
            <Text fontWeight="bold" fontSize="lg">Giro Comercial </Text>
            <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
              <Select
                placeholder="Selecciona ESTRUCTURA_SCIAN"
                value={scianId}
                onChange={onChangeScian}
                isDisabled={modo === 'view'}
              >
                {scianCatalog.map((item) => (
                  <option key={item.ID} value={item.ID}>
                    {item.ESTRUCTURA_SCIAN}
                  </option>
                ))}
              </Select>

              <Input
                placeholder="CLAVE_SCIAN"
                value={CLAVE_SCIAN}
                isReadOnly
              />
              <Input
                placeholder="MONTO_UMA (texto)"
                value={MONTO_UMA}
                isReadOnly
              />
              {/* <Input
                placeholder="UMA mínimo"
                value={minimo_uma}
                isReadOnly
              />
              <Input
                placeholder="UMA máximo"
                value={maximo_uma}
                isReadOnly
              /> */}
            </SimpleGrid>
            <Input
              placeholder="Descripción "
              value={DESCRIPCION}
              isReadOnly
            />
            {/* ========================================================= */}

            <Text fontWeight="bold">Ubicación</Text>
            <InputGroup>
              <Input placeholder="Buscar dirección" value={direccion} onChange={(e) => setDireccion(e.target.value)} isReadOnly={modo === 'view'} />
              <InputRightElement>
                <Button size="sm" onClick={buscarDireccion} isDisabled={modo === 'view'}>Buscar</Button>
              </InputRightElement>
            </InputGroup>
            <Box h="250px" w="100%" border="1px solid #ccc" borderRadius="md" overflow="hidden">
              {isLoaded && (
                <GoogleMap
                  zoom={15}
                  center={{ lat, lng }}
                  mapContainerStyle={{ width: '100%', height: '100%' }}
                >
                  <Marker
                    position={{ lat, lng }}
                    draggable={modo !== 'view'}
                    onDragEnd={(e) => {
                      setLat(e.latLng?.lat() || lat);
                      setLng(e.latLng?.lng() || lng);
                    }}
                  />
                </GoogleMap>
              )}
            </Box>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose} variant="ghost">Cerrar</Button>
          {(modo === 'new' || modo === 'edit') && (
            <Button bg="#5b182b" color="white" _hover={{ bg: "#8a1f35" }} onClick={handleSubmit}>Guardar</Button>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalSolicitud;
